
import axios from '@/plugins/axios';
// import cf from '@/mixins/commonFunctions';

const actions = {
  getCustomer({ commit, dispatch }, data) {
    axios({
      method: 'GET',
      url: '/v1/stripe/get/customer/stripeData',
      params: {
        customerId: data.customer.customer_id,
      },
    })
      .then((response) => {
        const res = response.data;
        dispatch('getCardData', data);
        commit('putDefaultSource', res.customer.default_source);
      })
      .catch((error) => {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      });
  },

  /** IDを元にカード詳細を取得 */
  getCardData({ commit }, data) {
    axios({
      method: 'GET',
      url: '/v1/stripe/get/customer/cards',
      params: {
        customerId: data.customer.customer_id,
      },
    })
      .then((response) => {
        const res = response.data;
        if (res.data.cards.length) {
          commit('putAllData', {
            name: 'cards',
            data: res.data.cards,
          });
        }
      })
      .catch((error) => {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      });
  },

  setTemporaryCard({ commit }, data) {
    commit('setTemporaryCard', data);
  },

  resetTemporaryCard({ commit }) {
    commit('resetTemporaryCard');
  },

  reset({ commit }) {
    commit('reset');
  },
};


const mutations = {
  /** obj.dataがobject */
  putObjectData(state, obj) {
    const keys = Object.keys(obj.data);
    if (!keys.length) return;

    const items = Object.keys(state[obj.name]);
    // state.stripeに含まれる項目のみを追加
    keys.forEach((key) => {
      if (items.includes(key)) {
        state[obj.name][key] = obj.data[key];
      }
    });
  },

  /** obj.dataのすべてを格納 */
  putAllData(state, obj) {
    if (obj.name === 'cards') {
      state.cards[obj.name] = obj.data;
      state.cards.flag = true;
    } else {
      state[obj.name] = obj.data;
    }
  },

  putDefaultSource(state, id) {
    state.cards.default = id;
  },

  setTemporaryCard(state, data) {
    state.cards.temporary = data;
  },

  resetTemporaryCard(state) {
    state.cards.temporary = {};
  },

  reset(state) {
    state.cards.flag = false;
    state.cards.default = null;
    state.cards.cards = [];
    state.cards.temporary = {};
  },
};


const state = {
  cards: {
    flag: false,
    default: null,
    cards: [],
    temporary: {},
  },
};


export default {
  namespaced: true,
  actions,
  mutations,
  state,
};
